// extracted by mini-css-extract-plugin
module.exports = {"main":"MainContainer_main__1G9Cl"};